<template>
  <div class="modal" v-if="show">
    <div class="modal-content">
      <h1>{{$t('URL')}}</h1>
      <b-form-group :label="$t('pasteURL')">
        <b-input v-model="url" id="url" />
      </b-form-group>
      <div class="modal-actions">
        <button class="btn btn-light" @click="show = false;">{{$t('cancel')}}</button>
        <button class="btn btn-primary ml-2" @click="insertLink">{{$t('addLink')}}</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      url: '',
      command: null,
      show: false
    };
  },
  methods: {
    showModal(command) {
      // Add the sent command
      this.command = command;
      this.show = true;
    },
    insertLink() {
      // Some check can be done here, like if `youtubeID` is not false.
      const data = {
        command: this.command,
        data: {
          href: this.url
        }
      };

      this.$emit('onConfirm', data);
      this.show = false;
      this.url = '';
    }
  }
};
</script>

<style scoped>
  .modal {
    display: flex;
    align-items: center;
    justify-content: center;
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background-color: rgba(0, 0, 0, 0.5);
  }

  .modal-content {
    width: 100%;
    max-width: 600px;
    padding: 1.5rem 2rem;
    border-radius: 4px;
  }

  .modal-actions {
    text-align: right;
  }
</style>

